import { Link } from "react-router-dom";
import { NAV_LINKS } from "../data/site";

export const Footer = () => (
  <footer className="bg-night text-sand">
    <div className="mx-auto max-w-7xl px-4 pb-10 pt-20 sm:px-8 sm:pt-28 lg:px-16">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Link to="/" data-testid="footer-logo" className="flex items-center gap-3">
            <img src="/assets/logo-badge-dark.png" alt="Studio Solutions LLC" className="h-12 w-12 rounded-full" />
            <span className="font-display text-xl font-extrabold tracking-tight">Studio Solutions LLC</span>
          </Link>
          <p className="mt-6 max-w-sm font-serif text-xl italic leading-relaxed text-sand/60">
            Story. Scene. Sound. — video, marketing, content, branding, studio builds and production
            under one Wisconsin roof.
          </p>
          <div className="mt-8 space-y-2 font-mono text-xs uppercase tracking-[0.2em] text-sand/50">
            <p>Wisconsin, USA</p>
            <p>
              <a
                data-testid="footer-email-link"
                href="mailto:Alan@studiosolutionsfdl.com"
                className="transition-colors duration-300 hover:text-gold"
              >
                Alan@studiosolutionsfdl.com
              </a>
            </p>
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Explore</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-").replace(/&/g, "")}`}
                  className="font-display text-sm font-bold uppercase tracking-widest text-sand/70 transition-colors duration-300 hover:text-gold"
                >
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/about"
                data-testid="footer-link-about"
                className="font-display text-sm font-bold uppercase tracking-widest text-sand/70 transition-colors duration-300 hover:text-gold"
              >
                About
              </Link>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Start Something</p>
          <p className="mt-5 text-sm leading-relaxed text-sand/60">
            Every project starts with a short conversation. Inquiries run through HoneyBook — quick,
            secure, and no obligation.
          </p>
          <Link
            to="/start-a-project"
            data-testid="footer-cta-start-project"
            className="mt-6 inline-block bg-gold px-6 py-3.5 font-display text-xs font-bold uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:bg-sand"
          >
            Start a Project
          </Link>
        </div>
      </div>

      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-sand/10 pt-6 sm:flex-row sm:items-center">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-sand/40">
          © 2026 Studio Solutions LLC · Made in Wisconsin
        </p>
        <div className="flex gap-6">
          <Link
            to="/privacy"
            data-testid="footer-link-privacy"
            className="font-mono text-[10px] uppercase tracking-[0.25em] text-sand/40 transition-colors duration-300 hover:text-gold"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-link-terms"
            className="font-mono text-[10px] uppercase tracking-[0.25em] text-sand/40 transition-colors duration-300 hover:text-gold"
          >
            Terms
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
